import { render } from "./ProcedureActions.vue?vue&type=template&id=d4f520ae&scoped=true"
import script from "./ProcedureActions.vue?vue&type=script&lang=js"
export * from "./ProcedureActions.vue?vue&type=script&lang=js"

import "./ProcedureActions.vue?vue&type=style&index=0&id=d4f520ae&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4f520ae"]])

export default __exports__